// A title's punctuation remains in its saved text. Exhibition typography can
// express a title and subtitle through spacing without altering that record.
export function exhibitionTitleParts(value) {
  const text = String(value || '').trim();
  for (let i = 1; i < text.length - 1; i++) {
    if (!/[:：]/u.test(text[i])) continue;
    if (/\d/u.test(text[i - 1]) && /\d/u.test(text[i + 1])) continue;
    if (text.slice(i + 1, i + 3) === '//') continue;
    const title = text.slice(0, i).trim(), subtitle = text.slice(i + 1).trim();
    if (title && subtitle) return [title, ...exhibitionTitleParts(subtitle)];
  }
  return [text];
}

function linesFor(context, text, width) {
  const tokens = text.match(/[\u2E80-\u9FFF\uF900-\uFAFF]|[^\s\u2E80-\u9FFF\uF900-\uFAFF]+\s*/gu) || [];
  const lines = []; let line = '';
  for (const token of tokens) {
    if (line && context.measureText(line + token).width > width) { lines.push(line.trim()); line = ''; }
    for (const char of token) {
      if (line && context.measureText(line + char).width > width) { lines.push(line.trim()); line = ''; }
      line += char;
    }
  }
  if (line.trim()) lines.push(line.trim());
  return lines;
}

export function layoutExhibitionTitle(context, text, { width, height, fontSize, family, align = 'left', subtitleScale = .88, subtitleGap = .24 }) {
  const parts = exhibitionTitleParts(text);
  let size = fontSize, result;
  // Uniform type scaling keeps glyph proportions intact for long and CJK
  // headings. Never use fillText's maxWidth, which squashes the lettering.
  do {
    let y = 0; const lines = [];
    parts.forEach((part, index) => {
      const partSize = size * (index ? subtitleScale : 1);
      context.font = `${partSize}px ${family}`;
      if (index) y += size * subtitleGap;
      for (const text of linesFor(context, part, width)) {
        lines.push({ text, size: partSize, y });
        y += partSize * 1.24;
      }
    });
    result = { lines, height: y, family, align, width };
    size *= .94;
  } while (result.height > height && size > 1);
  return result;
}

export function paintExhibitionTitle(context, text, x, y, options) {
  const layout = layoutExhibitionTitle(context, text, options);
  context.save(); context.textBaseline = 'top'; context.textAlign = layout.align;
  for (const line of layout.lines) {
    context.font = `${line.size}px ${layout.family}`;
    context.fillText(line.text, x + (layout.align === 'center' ? layout.width / 2 : 0), y + line.y);
  }
  context.restore();
  return y + layout.height;
}
